import type { MechanismType } from './types';

export type ExpandableMechanismType =
  | 'socket'
  | 'bathroom_socket'
  | 'kitchen_socket'
  | 'switch'
  | 'switch_double'
  | 'tv'
  | 'internet';

export const EXPANDABLE_MECHANISM_TYPES: ExpandableMechanismType[] = [
  'socket',
  'bathroom_socket',
  'kitchen_socket',
  'switch',
  'switch_double',
  'tv',
  'internet',
];

const MECHANISM_TO_PLACED_TYPE: Record<ExpandableMechanismType, string> = {
  socket: 'socket_single',
  bathroom_socket: 'bathroom_socket',
  kitchen_socket: 'kitchen_socket',
  switch: 'switch',
  switch_double: 'switch_double',
  tv: 'tv_socket',
  internet: 'rj45_socket',
};

export function isExpandableMechanismType(type: MechanismType): type is ExpandableMechanismType {
  return EXPANDABLE_MECHANISM_TYPES.includes(type as ExpandableMechanismType);
}

export function mechanismToPlacedType(type: MechanismType): string | null {
  return isExpandableMechanismType(type) ? MECHANISM_TO_PLACED_TYPE[type] : null;
}
